export enum PlatformFeature {
  DASHBOARD = "dashboard",
  PAYMENTS = "payments",
  TERMINALS = "terminals",
  ACCOUNT = "account",
  USERS = "users",
  HELP = "help",
  LOGOUT = "logout",
  CUSTOMERS = "customers",
  PAYMENT_LINKS = "paymentLinks",
  PRODUCTS = "products",
  FORMS = "forms",
  FLEET_MANAGEMENT = "fleetManagement",
  MANAGEMENT = "management",
  SETTINGS = "settings",
  PRODUCT_CATALOG = "productCatalog",
  INVENTORY = "inventory",
  LOCATION_BASED_INVENTORY = "locationBasedInventory",
  REPORTS = "reports",
  IMPORT_DATA = "importData",
  TAXES = "taxes",
  KIOSK = "kiosk",
  RECEIPT_PRINTER = "receiptPrinter",
  CUSTOM_EMAILED_RECEIPTS = "customEmailedReceipts",
  ONLINE_PAYMENTS = "onlinePayments",
  WEBHOOKS = "webhooks",
}
